
<template>

  <main :class="genOuterClass()">
    <div v-for="(b, i) in buildings" :class="genBldgClass()" @click="navBldg(b.id)">
      <div class="mobile-bldg-header" :style="{'border': $screen.breakpoint === 'sm' ? '1px solid rgb(0,153,191)' : 'none', 'border-bottom': $screen.breakpoint === 'sm' ? '5px solid rgb(0,153,191)' : 'none'}">
        <v-popover offset="8" trigger="hover" placement="right">
          <div class="mobile-header-text">
            <h5>{{b.info.name.length < 25 ? b.info.name : `${b.info.name.substring(0, 25)}...`}}</h5>
            <small>{{parseInt(b.aboveGround) + parseInt(b.belowGround)}} {{setLangFloors(b)}}
              <span style="color:rgb(0,153,191)">||</span> {{aggRooms(b)}}
            </small>
          </div>
          <template slot="popover">
            <hover-component :options="{type: 'mini', text: `${b.info.city}, ${b.info.country}`, exception: true}"></hover-component>
          </template>
        </v-popover>
        <div class="mobile-header-img">
          <img src="https://brebe-s3-storage-matt.s3-eu-west-1.amazonaws.com/breezi-pro/company.png" />
        </div>
      </div>
      <div class="mobile-bldg-body" v-if="$screen.breakpoint === 'sm'">
        <div class="mobile-rdg-icon" v-for="rdg in rdgs">
          <img :src="getRdgIcon(b, rdg).img" />
        </div>
      </div>
      <div class="mobile-bldg-body mobile-bldg-wrap-body" v-else>
        <h5 class="daily-avg">{{clauses.avg}}</h5>
        <div class="bldg-rdg-row" v-for="rdg in rdgs">
          <div class="row-rdg">
            <img :src="getRdgIcon(b, rdg).img" />
          </div>
          <v-popover offset="3" trigger="hover" placement="left" v-if="b.meas[rdg] === 'no data'">
            <h5 :style="{'color': getRdgIcon(b, rdg).color}">{{switchUnits(b, rdg)}} {{b.meas[rdg] !== 'no data' ? parseUnits(rdg) : ''}}</h5>
            <template slot="popover">
              <hover-component :options="noDataHover()"></hover-component>
            </template>
          </v-popover>
          <h5 v-else :style="{'color': getRdgIcon(b, rdg).color}">{{switchUnits(b, rdg)}} {{b.meas[rdg] !== 'no data' ? parseUnits(rdg) : ''}}</h5>
        </div>
      </div>
    </div>
    <div class="mobile-bldg-col add-mobile" v-if="$screen.breakpoint === 'sm'" @click="$store.dispatch('initOnboard', 'bldg')">
      <img src="https://brebe-s3-storage-matt.s3-eu-west-1.amazonaws.com/breezi-pro/company.png" style="height:50px;"/>
      <h3 style="margin:0px;margin-top:8px;">Add Building</h3>
      <h1 style="margin:0px;">+</h1>
    </div>
    <div class="card mobile-bldg-row" v-if="$screen.breakpoint !== 'sm'" @click="$store.dispatch('initOnboard', 'bldg')">
      <div class="mobile-bldg-body mobile-bldg-wrap-body" style="height:100%;justify-content:center;">
        <img src="https://brebe-s3-storage-matt.s3-eu-west-1.amazonaws.com/breezi-pro/company.png" style="height:60px;"/>
        <h3 style="margin-bottom:2px;">{{clauses.add}}</h3>
        <h1 style="margin-top:0px;">+</h1>
      </div>
    </div>
  </main>

</template>

<script>

import cToF from 'celsius-to-fahrenheit';

import Thresh from '@/lib/threshParser';
import Lang from '@/lib/langTemplates/OrgTemplate';

import Hover from '../hover/Hover';

export default {

  data(){
    return {
      rdgs: ['days', 'ttp', 'hhm', 'iaq', 'co2']
    }
  },

  components: {
    'hover-component': Hover
  },

  computed: {
    buildings(state){
      return this.$store.state.buildings;
    },
    clauses(){
      let lPref = this.$store.state.lang;
      return Object.keys(Lang.clauses).reduce((a, i) => {
        a[i] = Lang.clauses[i][lPref];
        return a;
      }, {});
    }
  },

  methods: {

    genOuterClass(){
      return `mobile-org-outer${this.$screen.breakpoint === 'sm' ? '' : '-wrap'}`
    },

    genBldgClass(){
      return this.$screen.breakpoint === 'sm' ? 'mobile-bldg-col' : 'card mobile-bldg-row';
    },

    getRdgIcon(b, rdg){
      if (b.meas[rdg] === 'no data') {
        return Thresh.parseThresh({}, rdg, true);
      } else {
        return Thresh.parseThresh(b.alerts, rdg);
      }
    },

    switchUnits(b, rdg){
      return (rdg === 'ttp' && b.meas[rdg] !== 'no data' && !this.$store.state.user.metric)
        ? Math.floor(cToF(b.meas[rdg]))
        : (b.meas[rdg] === 'no data'
            ? this.clauses.learning
            : b.meas[rdg]);
    },

    parseUnits(rdg){
      switch (rdg) {
        case 'days':
          return this.clauses.days;
          // TODO: pluralize
        break;
        case 'ttp':
          return `˚${this.$store.state.user.metric ? 'C' : 'F'}`
        break;
        case 'hhm':
          return '%';
        break;
        case 'iaq':
          return '';
        break;
        case 'co2':
          return 'ppm'
        break;
      }
    },

    aggRooms(b){
      let roomCount = b.floors.reduce((a, i) => {
        if (i.rooms) {
          i.rooms.forEach(r => {
            if (
              !Object.keys(r.meas).every(x => r.meas[x] === 'no data')
            ) a ++;
          });
        }
        return a;
      }, 0);
      return `${roomCount} ${this.clauses[roomCount === 1 ? 'room' : 'rooms']}`
    },

    navBldg(id){
      this.$store.dispatch('initCurrentBldg', id);
    },

    setLangFloors(b){
      return this.clauses[b.aboveGround + b.belowGround === 1 ? 'floor' : 'floors'];
    },

    noDataHover(){
      return {
        type: 'full',
        title: 'No data yet',
        content: [
          {
            sub: '',
            body: 'This building is still awaiting its first measurement point for this reading. If you have recently installed your first AirPulse, please note that it can take up to 24 hours for data to first reach our DB and become visible to you.'
          }
        ]
      }
    }

  },

  mounted(){
    if (Math.floor(Date.now()/1000) >= this.$store.state.sessionEnd) {
      this.$store.dispatch('logoutNotif');
      this.$router.push({path: '/'});
    } else {
      this.$store.dispatch('setNav', ['org']);
      this.$store.dispatch('componentHeader', {
        type: 'org',
        title: this.$store.state.org.name,
        lgText: this.$store.state.buildings.length,
        smText: `Building${this.$store.state.buildings.length === 1 ? '' : 's'}<br />Monitored`,
        alerts: this.$store.state.overallAlerts
      });
      this.$store.dispatch('switchBubbles', true);
    }
  }

}

</script>

<style>

.mobile-org-outer {
  width: 98vw;
  height: calc(100vh - 180px);
  max-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-x: hidden;
  overflow-y: scroll;
}

.mobile-org-outer-wrap {
  border-top: 1px solid rgb(0, 153, 191);
  padding: 10px;
  padding-bottom: 100px;
  margin-top: 10px;
  width: 70vw;
  min-width: 750px;
  height: calc(100vh - 80px);
  padding-bottom: 200px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;
  flex-wrap: wrap;
  overflow-x: hidden;
  overflow-y: scroll;
}

.mobile-bldg-col {
  width: 95%;
  height: 27%;
  min-height: 140px;
  max-height: 140px;
  background-color: #333237;
  margin: 5px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.add-col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  min-height: 120px;
  max-height: 120px;
  overflow: hidden;
}

.add-col img {
  height: 50px;
  /* margin: 10%; */
}

.add-col h3 {
  margin: 0px;
  margin-top: 10px;
  /* margin-top: 5px; */
}

.add-col h1 {
  margin: 0px;
}

.mobile-bldg-row:hover {
  box-shadow: 0px 0px 6px white;
}

.mobile-bldg-header {
  height: 30%;
  width: calc(100% - 2px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #325468;
  border: 1px solid rgb(0, 153, 191);
  border-bottom: 10px solid rgb(0, 153, 191);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.mobile-bldg-row .mobile-bldg-header {
  height: 15%;
}

.mobile-header-img {
  height: 100%;
  width: 80px;
  background-color: rgb(0, 153, 191);
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 4px;
}

.mobile-bldg-header img {
  height: 65%;
  margin-left: 4%;
}

.mobile-header-text {
  /* width: calc(100% - 80px); */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-left: 5px;
}

.mobile-header-text h5 {
  margin: 5px;
  color: rgb(0, 153, 191);
}

.mobile-header-text small {
  margin-left: 10px;
  font-size: .7em;
  font-weight: bolder;

}

.mobile-bldg-info {
  height: .8em;
  width: 100%;
  margin-top: 2%;
  border-bottom: 1px solid rgb(0, 153, 191);
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.mobile-bldg-info small {
  color: rgb(0, 153, 191);
  text-align: right;
  margin-right: 4%;
  font-size: .7em;
}

.mobile-bldg-body {
  height: 70%;
  width: calc(100% - 2px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  border: 1px solid rgb(0, 153, 191);
}

.mobile-bldg-wrap-body {
  height: 80%;
  flex-direction: column;
  justify-content: center;
  border: none;
}

.bldg-rdg-row {
  width: 80%;
  height: 18%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgb(0, 153, 191);
}

.row-rdg {
  width: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bldg-rdg-row img {
  height: 25px;
}

.mobile-bldg-body small {
  width: 30%;
  text-align: center;
  position: absolute;
  bottom: 2px;
  color: lightblue;
  border-top: 1px solid lightblue;
  padding-top: 3px;
  left: 35%;
}

.mobile-rdg-icon {
  width: 18%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 100%;
  margin: 15px;
}

.mobile-rdg-icon img {
  height: 95%;
}

.daily-avg {
  width: 80%;
  top: -15px;
  color: lightblue;
  border-bottom: 1px solid lightblue;
  text-align: right;
  font-size: .7em;
  font-weight: lighter;
  margin-bottom: 5px;
}

.add-mobile {
  height: 80px;
  overflow: hidden;
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>



// WEBPACK FOOTER //
// src/components/org/MobileOrg.vue